'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import { fetchBlogs } from '@eliadmin/core/src/api/blogs/blogs-api';
import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { BLOGS_CONFIG } from '@eliadmin/core/src/constants/blogs-config';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { getTextFromHTML } from '@eliadmin/core/src/utils/misc-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import React from 'react';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

function getIntlLocale(locale: string) {
  try {
    return Intl.getCanonicalLocales(locale.replaceAll('_', '-'))[0] ?? 'en';
  } catch {
    return 'en';
  }
}

export default function FirstBlog() {
  const locale = useLocaleStore(state => state.currentLocale);
  const intlLocale = getIntlLocale(locale);

  const { data: blogs } = useSuspenseQuery({
    queryKey: ['blogs', { locale, query: { orderBy: 'views', order: 'desc', results: 1 } }],
    queryFn: () =>
      fetchBlogs({
        locale,
        query: { orderBy: 'views', order: 'desc', results: 1 },
      }),
  });

  if (!blogs.data?.length) return null;

  /** TODO: top blogs filter */
  const textContent = getTextFromHTML(blogs.data[0].content).replace(/&nbsp;/gm, '');

  return (
    <>
      <div
        className="
        hidden
        w-full
        grid-cols-11
        md:grid
    "
      >
        <div className="relative col-span-6 h-[460px] w-full rounded-[10px]">
          <Link href={blogs?.data[0]?.slug ?? '#'} prefetch={false}>
            <Image
              src={blogs?.data[0]?.image?.url || '/images/placeholder.png'}
              alt={resolveImageAlt(blogs?.data?.[0]?.image, blogs?.data?.[0]?.name)}
              style={{ objectFit: 'cover' }}
              className="rounded-[10px]"
              fill
            />
            <Badge
              size={'md'}
              className={cn(
                'pointer-events-none flex flex-grow-0 select-none items-center gap-1 rounded-md bg-gray-100 px-2 text-xs font-semibold leading-5 text-foreground opacity-80',
                'ea-blog-card__date-badge',
                'absolute left-4 top-4',
              )}
            >
              {React.cloneElement(BLOGS_CONFIG.blogCard.calendarIcon as any, {
                className: cn('ea-availability-label__icon'),
              })}
              {new Date(blogs?.data[0]?.created_at).toLocaleDateString(intlLocale)}
            </Badge>
          </Link>
        </div>
        {/* <div className="flex w-full items-center justify-between">
          <div className="flex w-full items-center justify-start gap-1">
            {categories.map(category => (
              <Link
                key={category?.id}
                href={`/blog?filter=categories.id IN [${category?.id}]` || "#"}
                className="
                h-auto
                rounded-full
                bg-foreground
                px-4
                py-1
                text-[10px]
                font-semibold
                text-white
            " prefetch={false}
              >
                {category?.name}
              </Link>
            ))}
          </div>
        </div> */}
        <div className="col-span-5 flex h-full flex-col justify-center p-4">
          <Link href={blogs?.data[0]?.slug ?? '#'} prefetch={false}>
            <h2 className="text-3xl font-bold text-foreground">{blogs?.data[0]?.name}</h2>
          </Link>
          <HtmlRendererRaw
            as="p"
            className="my-1 line-clamp-5 overflow-y-hidden text-ellipsis text-sm text-foreground"
            html={textContent}
          />
        </div>
        {/* <Link
          href={ROUTES.BLOG_DETAIL({ slug: blogs?.data[0].slug })}
          className="
          flex
          h-[36px]
          w-full
          items-center
          justify-center
          gap-2
          rounded-full
          text-sm
          text-foreground
      " prefetch={false}
        >
          {t('text591')}
          <RiArrowRightSLine size={16} />
        </Link> */}
      </div>
      {/* <Separator className="h-[1px] w-full" /> */}
    </>
  );
}
